import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

export const IconFB = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm4.682 6.273A3.273 3.273 0 0 1 12.954 4h2.91c.2 0 .363.163.363.364v2.909c0 .2-.163.363-.363.363h-1.455a1.09 1.09 0 0 0-1.09 1.091v1.091h2.545a.364.364 0 0 1 .352.452l-.727 2.91a.36.36 0 0 1-.353.274h-1.818v6.182a.364.364 0 0 1-.364.364h-2.909a.364.364 0 0 1-.363-.364v-6.181H7.864a.364.364 0 0 1-.364-.364v-2.91c0-.2.163-.363.364-.363h1.818z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const IconIG = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.39.787A2.604 2.604 0 0 0 .786 3.39v6.944a2.604 2.604 0 0 0 2.604 2.604h6.944a2.604 2.604 0 0 0 2.603-2.604V3.39A2.604 2.604 0 0 0 10.334.787zm7.693 2.607a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m-4.22 1.388a2.08 2.08 0 1 0 0 4.16a2.08 2.08 0 0 0 0-4.16m-3.081 2.08a3.08 3.08 0 1 1 6.16 0a3.08 3.08 0 0 1-6.16 0"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const IconYT = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm-.5 11c0-1.074.05-2.087.117-2.937a2.54 2.54 0 0 1 2.36-2.358A71 71 0 0 1 12 6.545c2.157 0 3.812.074 5.023.16a2.54 2.54 0 0 1 2.36 2.358c.066.85.117 1.863.117 2.937c0 1.113-.054 2.16-.124 3.028c-.1 1.239-1.044 2.185-2.262 2.27a75 75 0 0 1-5.114.157c-2.178 0-3.89-.072-5.114-.157c-1.218-.085-2.162-1.031-2.262-2.27A38 38 0 0 1 4.5 12m5.636-2.545L14.386 12l-4.25 2.546z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const IconTikTok = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm7.34 3.5h2.387c0 1.6 1.352 3.41 3.41 3.41v2.386c-1.417-.098-2.628-.33-3.41-1.023v6.136c0 1.705-1.348 4.091-4.431 4.091c-3.766 0-4.432-3.41-4.432-4.432s.6-4.432 4.772-4.432v2.387c-1.091-.231-2.386.681-2.386 2.045c0 1.705 1.023 2.046 2.046 2.046s2.045-1.023 2.045-2.046z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const IconLine = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" viewBox="0 0 26 24" {...props}>
      <path
        fill="currentColor"
        d="m12.171 23.999l-.024.001a.4.4 0 0 1-.209-.064l.001.001c-.251-.197-.159-.676-.053-1.231a3.7 3.7 0 0 0 .098-1.4l.002.018a1.12 1.12 0 0 0-.984-.895h-.005a14.8 14.8 0 0 1-4.706-1.321l.091.038a13 13 0 0 1-1.842-1.042l.047.03a12 12 0 0 1-1.559-1.244l.006.005q-.69-.651-1.251-1.406l-.02-.029a9.3 9.3 0 0 1-.929-1.544l-.025-.057A8.26 8.26 0 0 1 0 10.266c0-.734.094-1.446.272-2.125l-.013.058a8.8 8.8 0 0 1 .77-1.974l-.023.047a10 10 0 0 1 1.198-1.754l-.011.013a11.3 11.3 0 0 1 1.543-1.506l.022-.017a12.6 12.6 0 0 1 1.831-1.221l.066-.033A13.5 13.5 0 0 1 7.734.838l.099-.03a14 14 0 0 1 2.318-.586L10.24.21a16.2 16.2 0 0 1 5.262.013L15.408.21c.922.152 1.732.36 2.514.63l-.107-.032c.847.288 1.566.608 2.251.983l-.073-.037c.722.393 1.343.808 1.922 1.273l-.025-.019c.578.464 1.09.963 1.552 1.507l.013.016c.435.51.827 1.081 1.156 1.691l.026.052c.301.551.558 1.191.737 1.863l.014.061a8.2 8.2 0 0 1 .26 2.069a8.3 8.3 0 0 1-.521 2.911l.019-.058a9.4 9.4 0 0 1-1.427 2.565l.015-.02a3 3 0 0 1-.239.298l.002-.002l-.008.009c-.428.508-.884.963-1.377 1.377l-.017.014a50 50 0 0 1-5.52 4.351l-.174.112a27 27 0 0 1-2.425 1.493l-.148.074a9 9 0 0 1-.916.428l-.06.021a2 2 0 0 1-.673.159h-.006zm5.983-16.742a.67.67 0 0 0-.668.668v4.958a.67.67 0 0 0 .668.668h2.586a.67.67 0 0 0 .668-.668v-.056a.67.67 0 0 0-.668-.668h-1.863v-1.057h1.862a.67.67 0 0 0 .668-.668v-.056a.67.67 0 0 0-.668-.668h-1.862V8.651h1.862a.67.67 0 0 0 .668-.668v-.057a.67.67 0 0 0-.668-.668zm-5.971-.012a.67.67 0 0 0-.668.668v4.958a.67.67 0 0 0 .668.668h.056a.67.67 0 0 0 .668-.668V9.905l2.434 3.325l.05.068l-.001-.001a.56.56 0 0 0 .253.191l.004.001c.075.032.162.05.253.05h.059a.66.66 0 0 0 .315-.08l-.004.002a.5.5 0 0 0 .163-.121v-.001a.66.66 0 0 0 .193-.468V7.913a.67.67 0 0 0-.668-.668h-.059a.67.67 0 0 0-.668.668v2.911l-2.414-3.241a.67.67 0 0 0-.58-.342zm-2.334 0a.67.67 0 0 0-.668.668v4.958a.67.67 0 0 0 .668.668h.056a.67.67 0 0 0 .668-.668V7.913a.67.67 0 0 0-.668-.668zm-4.462 0a.67.67 0 0 0-.668.668v4.958a.67.67 0 0 0 .668.668h2.584a.67.67 0 0 0 .668-.668v-.05a.67.67 0 0 0-.668-.668H6.11V7.914a.67.67 0 0 0-.668-.668z"
      />
    </svg>
  );
};

export const IconLineSquare = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="400" viewBox="0 0 448 512" {...props}>
      <path
        fill="currentColor"
        d="M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1m-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2m-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2c.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2M332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2M448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7m-61.6 122.6c0-73-73.2-132.4-163.1-132.4S60.2 163.3 60.2 236.3c0 65.4 58 120.2 136.4 130.6c19.1 4.1 16.9 11.1 12.6 36.8c-.7 4.1-3.3 16.1 14.1 8.8s93.9-55.3 128.2-94.7c23.6-26 34.9-52.3 34.9-81.5"
      />
    </svg>
  );
};

export const IconApple = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M17.05 20.28c-.98.95-2.05.8-3.08.35c-1.09-.46-2.09-.48-3.24 0c-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8c1.18-.24 2.31-.93 3.57-.84c1.51.12 2.65.72 3.4 1.8c-3.12 1.87-2.38 5.98.48 7.13c-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25c.29 2.58-2.34 4.5-3.74 4.25"
      />
    </svg>
  );
};
